export const fileToBase64DataUrl = (file: File | Blob): Promise<string> =>
	new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(`${reader.result}`);
		reader.onerror = reject;
	});

// Get mime type from base64 string
export const getMimeTypeFromDataUrl = (dataUrl: string) =>
	dataUrl.substring(dataUrl.indexOf(':') + 1, dataUrl.indexOf(';'));
